/**
 * Champ de code PIN à 4 chiffres (bascule de compte parent ⇄ enfant, 0301).
 * Pavé numérique sur mobile (`inputMode="numeric"`), chiffres masqués.
 */

import { cn } from '@jeraisonne/ui';

export function PinInput({
  id,
  value,
  onChange,
  autoFocus,
  label,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
  autoFocus?: boolean;
  label: string;
}) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-ink-700 text-sm font-semibold">
        {label}
      </label>
      <input
        id={id}
        type="password"
        inputMode="numeric"
        autoComplete="off"
        pattern="[0-9]*"
        maxLength={4}
        autoFocus={autoFocus}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 4))}
        className={cn(
          'border-ink-200 text-ink-900 focus:ring-primary-400 h-12 w-full rounded-xl border bg-white px-3 text-center text-2xl tracking-[0.6em] focus:outline-none focus:ring-2',
        )}
      />
    </div>
  );
}
